var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    clipPath: "url(#clip0_8_478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3333 1.99998C11.5084 1.82488 11.7163 1.68599 11.9451 1.59123C12.1738 1.49647 12.419 1.44769 12.6666 1.44769C12.9143 1.44769 13.1595 1.49647 13.3882 1.59123C13.617 1.68599 13.8249 1.82488 14 1.99998C14.1751 2.17507 14.314 2.38294 14.4087 2.61172C14.5035 2.84049 14.5523 3.08569 14.5523 3.33331C14.5523 3.58093 14.5035 3.82613 14.4087 4.05491C14.314 4.28368 14.1751 4.49155 14 4.66664L4.99998 13.6666L1.33331 14.6666L2.33331 11L11.3333 1.99998Z",
    stroke: "#042F24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.f9ce032df0c4940dc1b7856e7945bee3.svg";
export { ForwardRef as ReactComponent };